module.exports = __webpack_public_path__ + "img/FolderFile.2c83fcfc.svg";